import { render, staticRenderFns } from "./InvoiceStartedDialog.vue?vue&type=template&id=63bfc0d7&"
import script from "./InvoiceStartedDialog.vue?vue&type=script&lang=js&"
export * from "./InvoiceStartedDialog.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceStartedDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports